import { PaymentMethod } from '@/features/dashboard/tourConfig/types/PaymentMethod.ts';
import { TourConsentDto } from '@/features/dashboard/tourConsents/types/TourConsentDto.ts';
import { tourConsentDocumentsMapper } from '@/features/dashboard/bookingChanges/types/TourConsentDto.mapper.ts';
import { ChangeRoute } from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';
import { toChangeResolution } from '@/features/dashboard/bookingChanges/types/ChangeRoute.utils.ts';
import { ResolveBookingChangeRequest } from '@/features/dashboard/bookingChanges/types/dto/ResolveBookingChangeRequest.ts';

export interface ChangePackageResolveInput {
  consents: TourConsentDto[];
  route: ChangeRoute;
  selectedDocumentIds: string[];
  /** Termin linii korekty podany przez operatora (`YYYY-MM-DD`). */
  correctionDueDate: string | null;
  correctionPaymentMethods: PaymentMethod[];
}

/**
 * Złożenie wyborów operatora z kroku W2 w żądanie `resolve`.
 *
 * Termin i metody płatności korekty **nie** wynikają z podglądu harmonogramu:
 * na żadną kwotę nie mają wpływu, więc plan ich nie liczy, a paczka nosi je
 * dopiero od chwili, gdy operator je poda. Krok W2 zbiera je wprost.
 *
 * Trasa „wprowadź od razu” pomija akceptację, więc nie ma komu podpisać
 * dokumentów — zaznaczenie nie idzie wtedy w żądaniu wcale.
 */
export const toChangePackageResolveRequest = ({
  consents,
  route,
  selectedDocumentIds,
  correctionDueDate,
  correctionPaymentMethods,
}: ChangePackageResolveInput): ResolveBookingChangeRequest => {
  const amendmentTourConsentIds =
    route === ChangeRoute.CLIENT_ACCEPTANCE
      ? tourConsentDocumentsMapper.toAmendmentConsentIds(
          consents,
          selectedDocumentIds,
        )
      : [];

  return {
    resolution: toChangeResolution(route, amendmentTourConsentIds.length > 0),
    offlineAccepted: false,
    note: null,
    correctionDueDate,
    correctionPaymentMethods:
      correctionPaymentMethods.length > 0 ? correctionPaymentMethods : null,
    amendmentTourConsentIds:
      amendmentTourConsentIds.length > 0 ? amendmentTourConsentIds : null,
  };
};
